// @flow
export { default as Heading } from './Heading';
export { default as Paragraph } from './Paragraph';
export { default as Text } from './Text';



// WEBPACK FOOTER //
// ../react-lib/src/components/typography/index.js